export default __webpack_public_path__ + "static/media/arrow-down-sm-7x5.e9a052fe.svg";